import React, { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function ConsultPage() {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", description: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Form Data Submitted:", formData);
const response = await axios.post("http://localhost:3000/api/v1/enquiry", formData);


      if (response.status === 200) {
        setStatus(response.data.message || "Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", description: "" });
      }
    } catch (error) {
      if (error.response?.data?.error) {
        alert("❌ " + error.response.data.error.join("\n"));
      } else {
        alert("❌ " + (error.response?.data?.message || "Something went wrong."));
      }
      console.error(error);
    }
  };

  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <div
        className="text-white text-center d-flex align-items-center justify-content-center"
        style={{
          height: "60vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/wwd.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          animation: "fadeIn 2s ease-in-out",
        }}
      >
        <div>
          <h1 className="display-4 fw-bold mb-3">Consult Us</h1>
          <p className="lead">
            Looking to collaborate? Reach out to us for customized solutions.
          </p>
        </div>
      </div>

      <div className="row mt-5 px-4">
        {/* Left Column: Address and Map */}
        <div className="col-md-5 mb-5">
          <h4 className="mb-3">Visit Us At</h4>
          <p>
            Opp Hanamashetty Tyres Shop,
            <br />
            Gurukul Road, Vijayapura – 586101
          </p>
          <div className="ratio ratio-21x9">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3818.8437865269816!2d75.717896!3d16.834104000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTbCsDUwJzAyLjgiTiA3NcKwNDMnMDQuNCJF!5e0!3m2!1sen!2sin!4v1750752188408!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0 }}
            ></iframe>
          </div>
        </div>

        {/* Right Column: Contact Form */}
        <div className="col-md-6 mb-5">
          <form onSubmit={handleSubmit} className="mt-4">
            <div className="mb-3">
              <label>Name</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Phone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Message</label>
              <textarea
                name="description"
                rows="5"
                value={formData.description}
                onChange={handleChange}
                required
                className="form-control"
              ></textarea>
            </div>
            <button className="btn btn-primary" type="submit">
              Send Message
            </button>
          </form>

          {status && <p className="mt-3 text-success">{status}</p>}
        </div>
      </div>

      <Footer />
      <ScrollToTopButton />
    </>
  );
}
